/**
 * Main layout: header, page, bottom navigation. The fixed audio player is rendered once by
 * AppShell above this layout, so it keeps playing when the book reader (its own layout) opens.
 */
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { useIsPlayerVisible } from '@/store';

export function MainLayout() {
  const isPlayerVisible = useIsPlayerVisible();

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      {/* Room for the fixed bottom nav (+ safe-area inset), and for the player above it when visible */}
      <main
        className={`flex-1 ${
          isPlayerVisible
            ? 'pb-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom)+6.5rem)]'
            : 'pb-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom)+1.5rem)]'
        }`}
      >
        <Outlet />
      </main>
      {/* Bottom nav always visible like old frontend */}
      <BottomNav />
    </div>
  );
}
